/**
 * 展示层格式化。重量口径复用 @jilian/core 的 formatWeightDisplay（决策 14.15），
 * 其余为时间/日期/数字等轻量工具。
 */
import { formatWeightDisplay } from "@jilian/core";
import type { WeightUnitScope } from "@jilian/shared";

export { formatWeightDisplay };

/** 重量数字（去掉多余小数点，如 7.5 / 10 / 22.5）。 */
export function formatKg(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "—";
  const v = Math.round(n * 100) / 100;
  return Number.isInteger(v) ? String(v) : String(v);
}

/** 休息时长：120 → "2 分钟"，210 → "3.5 分钟"，90 → "1.5 分钟"。 */
export function formatRestSeconds(seconds: number): string {
  const m = seconds / 60;
  if (Number.isInteger(m)) return `${m} 分钟`;
  const rounded = Math.round(m * 10) / 10;
  return `${rounded} 分钟`;
}

/** 计时 display：78 秒 → "1:18"。 */
export function formatCountdown(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const mm = Math.floor(s / 60);
  const ss = s % 60;
  return `${mm}:${String(ss).padStart(2, "0")}`;
}

/** 训练时长：1500 秒 → "25 分钟"。 */
export function formatElapsed(seconds: number): string {
  if (seconds < 60) return `${Math.round(seconds)} 秒`;
  const m = Math.round(seconds / 60);
  return `${m} 分钟`;
}

/** ISO 日期 → "6 月 21 日 周五"。 */
export function formatCnDate(isoDate: string): string {
  const d = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(d.getTime())) return isoDate;
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"][d.getDay()];
  return `${month} 月 ${day} 日 ${week}`;
}

/** 今日标题：例如 "6 月 21 日 周五"。 */
export function todayTitle(date = new Date()): string {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"][date.getDay()];
  return `${month} 月 ${day} 日 ${week}`;
}

/** 重量口径的短标签（用于输入框旁提示「只/每侧/总重」）。 */
export function scopeShortLabel(scope: WeightUnitScope): string {
  switch (scope) {
    case "per_dumbbell":
      return "每只";
    case "per_side":
      return "每侧";
    case "machine_display":
      return "器械显示值";
    case "bodyweight":
      return "自重";
    case "bodyweight_plus":
      return "自重+负重";
    case "assistance":
      return "辅助";
    case "total":
    default:
      return "总重";
  }
}
